import { observable, action, computed, toJS } from 'mobx';
import { compareObject } from '../../js/utils';
import { getParkingSpaceByMac } from '../../service';

// 开启广播的地磁
export class BroadcastGeo {
  constructor(mac) {
    this.mac = mac;

    this.getParkingno();
  }

  lastData = {};

  // 从后台获取车位号
  getParkingno() {
    getParkingSpaceByMac(this.mac).then((data) => {
      this.parkingno = data.parkingno;
    });
  }

  @observable status = 'success';

  // 车位号
  @observable parkingno = '';

  // 检测日志
  @observable list = [];

  // 雷达状态
  @observable radarState = -1;

  @observable currentRadarState = -1;

  // 车位状态
  @observable state = -1;

  // 检测到车位状态变化的时间
  @observable detectTime = '';

  // 收到广播的时间
  @observable receiveTime = '';

  // 信号值
  @observable rssi = '';

  // 耗时
  @observable millis = '';

  @observable disabled = false;

  compareData(aData, bData) {
    return aData.state === bData.state
      && aData.detectTime === bData.detectTime
      && aData.radarState === bData.radarState;
  }

  @action push(data) {
    this.state = data.state;
    this.radarState = data.radarState;
    this.currentRadarState = data.currentRadarState;
    this.detectTime = data.detectTime;
    this.rssi = data.rssi;
    this.millis = data.millis;
    this.receiveTime = data.receiveTime;

    if (compareObject(data, this.lastData)) {
      return;
    }

    // 地磁向平台上传车位状态变化的第一包默认255s，所以需要从后面的包中更新耗时
    if (this.compareData(this.lastData, data)) {
      this.list.splice(this.list.length - 1, 1, data);
    }

    this.lastData = data;

    if (data.state !== this.lastList.state) {
      this.list.push(data);
    }
  }

  @computed get lastList() {
    return this.list.length === 0 ? {} : toJS(this.list[this.list.length - 1]);
  }

  @action updateState() {
    const lastTime = this.receiveTime;

    if (
      lastTime
      && (new Date() - new Date(lastTime.replace(/-/g, '/'))) > 60000
    ) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }
}

class BroadcastStore {
  // 已开启广播的地磁列表
  listMap = {};

  monitorTimer = null;

  openMonitor = true;

  @observable listArr = [];

  @observable open = false;

  @computed get macList() {
    return toJS(this.listArr).map((item) => {
      return {
        mac: item,
        status: this.listMap[item].status
      };
    });
  }

  @computed get list() {
    return toJS(this.listArr).map(item => this.listMap[item]);
  }

  @action push(mac, data) {
    if (this.listMap[mac]) {
      this.listMap[mac].status = 'loading';
    } else {
      this.listArr.push(mac);
      this.listMap[mac] = new BroadcastGeo(mac);

      if (data) {
        this.listMap[mac].push(data);
      }
    }
  }

  @action scan(data) {
    const broadcastGeo = this.listMap[data.mac];
    if (broadcastGeo) {
      broadcastGeo.push(data);
    } else {
      this.push(data.mac, data);
    }
  }

  @action updateState(mac, state) {
    if (!this.listMap[mac]) {
      return;
    }

    this.listMap[mac].status = state;
  }

  monitor() {
    Object.values(this.listMap).forEach((geo) => {
      geo.updateState();
    });
  }

  executeMonitor() {
    if (!this.openMonitor) {
      return;
    }
    this.monitor();
    this.monitorTimer = setTimeout(() => {
      this.executeMonitor();
    }, 60000);
  }

  // 开启一分钟监控，如果存在1分钟无广播的，将卡片置灰
  @action startMonitor() {
    this.openMonitor = true;
    this.executeMonitor();
  }

  @action stopMonitor() {
    this.openMonitor = false;
    clearTimeout(this.monitorTimer);
  }

  @action reset() {
    this.listMap = {};
    this.listArr = [];
    this.open = false;
  }
}

export default BroadcastStore;

export const broadcastStore = new BroadcastStore();
